import { render } from "./Home.vue?vue&type=template&id=ba3191a8&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=ba3191a8&scoped=true&lang=css"

import exportComponent from "/tmp/workdir/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba3191a8"]])

export default __exports__